import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from "@eb/i18n";
import classNames from 'classnames';
import { MailChunky } from '@eb/eds-iconography';
import { AlertChunky } from '@eb/eds-iconography';

import NotificationScreen from '../../components/NotificationScreen';

import { SOFT_ACCOUNT_EMAIL_STATUSES } from '../../constants/status';

import './SoftAccountStatusContent.scss';

/**
 * List of urls that will lead to this page:
 * * BASE_URL/SOFT_ACCOUNT_STATUS_PATH
 */
export default class SoftAccountStatusContent extends React.Component {
    static propTypes = {
        email: PropTypes.string,
        softAccountEmailStatus: PropTypes.string,
    };

    render() {
        const { email, softAccountEmailStatus } = this.props;
        const componentClasses = classNames(
            'eds-l-mar-vert-14',
            'soft-account-status-content',
        );

        let iconType = <MailChunky />;

        let headerText = gettext('Check your inbox');

        let subtitleText = gettext(
            'We sent you and email to %(email)s with instruction to set your password.',
            { email },
        );

        if (softAccountEmailStatus === SOFT_ACCOUNT_EMAIL_STATUSES.failed) {
            headerText = gettext('There has been an error');
            subtitleText = gettext('Please try again later');
            iconType = <AlertChunky />;
        }

        return (
            <div className={componentClasses}>
                <NotificationScreen
                    iconColor="ui-700"
                    iconType={iconType}
                    headerText={headerText}
                    subtitleText={subtitleText}
                    usesNewStyles={true}
                />
            </div>
        );
    }
}
